import React from 'react'
import ReactResizeDetector from 'react-resize-detector'
import { useSelector } from 'react-redux'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import NewsTickerControlButtonContainer from 'redux/containers/pages/dashboard/NewsTickerControlButtonContainer'
import onClickOutside from 'react-onclickoutside'
import selectCmsCtx from 'redux/selectors/selectCmsCtx'
import NewsTickerTextCms from 'pages/dashboard/NewsTickerTextCms'

const NewsTicker = ({ resumeNewsTicker }) => {
  NewsTicker.handleClickOutside = () => resumeNewsTicker()

  const { isLargeDesktop } = useSelector(selectDeviceType)

  return (
    <div className='bg-twilight-grey h-100 flex items-center'>
      <div className='h-100 bg-light-sea-green-2 flex items-center grow-0 shrink-0'>
        {isLargeDesktop ? <div className='ph4 white f5'>Updates</div> : <NewsTickerControlButtonContainer />}
      </div>
      <div className='black shrink-1 grow-1 basis0 relative overflow-hidden h-100 f6 w-100'>
        <ReactResizeDetector handleWidth>
          <ResizeNewsTickerTextCms />
        </ReactResizeDetector>
      </div>
    </div>
  )
}

const ResizeNewsTickerTextCms = ({ width }) => {
  const cmsCtx = useSelector(selectCmsCtx)

  return (
    <div className='w-100'>
      {cmsCtx && <NewsTickerTextCms {...{ cmsCtx, width }} />}
    </div>
  )
}

const clickOutsideConfig = {
  handleClickOutside: () => NewsTicker.handleClickOutside
}

export default onClickOutside(NewsTicker, clickOutsideConfig)
